import { useState, useEffect, useContext } from 'react';
import { useForm } from '../../../hooks';

import { Button, Grid, IconButton, MenuItem, Typography } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

import StyledModal from '../StyledModal';
import colors from '../../../assets/colors';
import { TextField, Button as StyledButton } from '../../common';
import { storage } from '../../../utils/api';
import FarmContext from '../../../store/farm-context';

export default function EditWarehouseItemModal(props) {
  const farmCTX = useContext(FarmContext);
  const [isFormDataComplete, setIsFormDataComplete] = useState(false);
  const [isRequestedChangeNegative, setIsRequestedChangeNegative] =
    useState(false);
  const [isEventNegative, setIsEventNegative] = useState(false);
  const [isAmountNegative, setIsAmountNegative] = useState(false);

  const handleClose = () => props.setOpen(false);
  const handleOpenDeleteModal = () => {
    handleClose();
    props.setOpenDelete(true);
  };
  const handleEditWarehouseItem = () => {
    editWarehouseItem();
    handleClose();
  };

  const { handleChange, values } = useForm({
    activity: '',
    amount: '',
  });

  useEffect(() => {
    if (values.activity === 'zakup' || values.activity === 'wyprodukowanie') {
      setIsEventNegative(false);
    } else {
      setIsEventNegative(true);
    }
    if (values.amount.length > 0 && values.activity.length > 0) {
      setIsFormDataComplete(true);
    } else {
      setIsFormDataComplete(false);
    }
    if (parseFloat(values.amount) <= 0) {
      setIsAmountNegative(true);
    } else setIsAmountNegative(false);
    if (isEventNegative) {
      if (
        values.amount.length > 0 &&
        props.storedAmount - parseFloat(values.amount) >= 0
      ) {
        setIsRequestedChangeNegative(false);
      } else if (props.storedAmount - parseFloat(values.amount) < 0) {
        setIsRequestedChangeNegative(true);
      }
    } else setIsRequestedChangeNegative(false);
  }, [
    values.activity,
    values.amount,
    props.storedAmount,
    isEventNegative,
    isAmountNegative,
  ]);

  const editWarehouseItem = () => {
    let amountToChange;
    if (isEventNegative) {
      amountToChange = values.amount * -1;
    } else {
      amountToChange = values.amount;
    }
    const body = {
      activity: values.activity,
      amount: amountToChange,
    };
    storage
      .edit(props.id, farmCTX.farmID, body)
      .then(() => props.updateWarehouse())
      .catch(() => {});
  };

  return (
    <StyledModal open={props.open}>
      <IconButton
        onClick={handleClose}
        sx={{
          color: colors.redButton,
          position: 'absolute',
          top: 5,
          right: 5,
        }}
      >
        <CancelIcon />
      </IconButton>
      <Grid container justifyContent="center">
        <Typography sx={{ fontSize: 36, fontWeight: 500, mb: 4, mt: 1 }}>
          Zarządzaj zasobem
        </Typography>
      </Grid>
      <Grid container direction={'row'} justifyContent="space-between">
        <Grid item xs={12} lg={6}>
          <TextField
            modal
            select
            size="small"
            label="Nazwa aktywności"
            value={values.activity}
            onChange={handleChange('activity')}
            sx={{ textAlign: 'left' }}
          >
            <MenuItem value={'zakup'}>Zakup</MenuItem>
            <MenuItem value={'wyprodukowanie'}>Wyprodukowanie</MenuItem>
            <MenuItem value={'sprzedaż'}>Sprzedaż</MenuItem>
            <MenuItem value={'zużycie'}>Zużycie</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            modal
            size="small"
            label="Ilość do zmiany"
            type="number"
            onChange={handleChange('amount')}
            error={isRequestedChangeNegative || isAmountNegative}
            helperText={
              isAmountNegative
                ? 'Podana wartość jest mniejsza lub równa zero, podaj wartość dodatnią'
                : isRequestedChangeNegative &&
                  'Odejmowana wartość przekracza Twój stan magazynowy'
            }
          />
        </Grid>
      </Grid>
      <Grid container justifyContent="space-between">
        <StyledButton
          red
          type="submit"
          variant="outlined"
          onClick={handleOpenDeleteModal}
          sx={{ mt: 2 }}
        >
          USUŃ ZASÓB
        </StyledButton>
        <Button
          type="submit"
          variant="outlined"
          onClick={handleEditWarehouseItem}
          sx={{ mt: 2 }}
          disabled={
            !isFormDataComplete || isRequestedChangeNegative || isAmountNegative
          }
        >
          ZAPISZ ZMIANY
        </Button>
      </Grid>
    </StyledModal>
  );
}
